export default __webpack_public_path__ + "static/media/vip-banner-one-mobile.990cea11.png";